// Action types for saving data
export const GET_STORE_DATA_REQUEST = 'GET_STORE_DATA_REQUEST';
export const GET_STORE_DATA_SUCCESS = 'GET_STORE_DATA_SUCCESS';
export const GET_STORE_DATA_FAILURE = 'GET_STORE_DATA_FAILURE';
export const GET_STORE_DATA_RESET = 'GET_STORE_DATA_RESET';
// Save data actions
export const getStoreDataRequest = (payload) => ({
    type: GET_STORE_DATA_REQUEST,
    payload
});
export const getStoreDataSuccess = (payload) => ({
    type: GET_STORE_DATA_SUCCESS,
    payload,
});
export const getStoreDataFailure = (error) => ({
    type: GET_STORE_DATA_FAILURE,
    payload: error,
});
export const getStoreDataReset = () => ({
    type: GET_STORE_DATA_RESET,
});
